import * as React from 'react';

import { IRouter, Link } from 'react-router';
import { IOwner, IRouterContext } from '../../types';
import { url, safeJsonParse, createFetchOptions } from '../../util';

import OwnersTable from './OwnersTable';


interface IFindOwnersPageProps {
  location: any;
}

interface IFindOwnersPageState {
  owners?: IOwner[];
  filter?: string;
  successMessage?: string;
}

const getFilterFromLocation = (location) => {
  return location.query ? (location.query as any).lastName : null;
};

export default class FindOwnersPage extends React.Component<IFindOwnersPageProps, IFindOwnersPageState> {
  context: IRouterContext;

  static contextTypes = {
    router: React.PropTypes.object.isRequired
  };

  constructor(props: IFindOwnersPageProps) {
    super(props);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.submitSearchForm = this.submitSearchForm.bind(this);
    this.dismissSuccessMessage = this.dismissSuccessMessage.bind(this);

    const filter = getFilterFromLocation(props.location);
    const successMessage = props.location.query && props.location.query.success 
      ? decodeURIComponent(props.location.query.success) 
      : undefined;

    this.state = {
      filter: filter,
      successMessage: successMessage
    };
  }

  componentDidMount() {
    const { filter } = this.state;
    if (typeof filter === 'string') {
      // only load data on mount (initialy) if filter is specified
      // i.e. lastName query param in uri was set
      this.fetchData(filter);
    }
  }

  componentWillReceiveProps(nextProps: IFindOwnersPageProps) {
    const { location } = nextProps;

    // read the filter from uri
    const filter = getFilterFromLocation(location);
    
    // read success message from query params
    const successMessage = location.query && location.query.success 
      ? decodeURIComponent(location.query.success) 
      : undefined;

    // set state
    this.setState({ 
      filter: filter,
      successMessage: successMessage
    });

    // load data according to filter
    this.fetchData(filter);
  }

  onFilterChange(event) {
    this.setState({
      filter: event.target.value as string
    });
  }

  /**
   * Invoked when the submit button was pressed.
   * 
   * This method updates the URL with the entered lastName. The change of the URL
   * leads to new properties and thus results in rerending
   */
  submitSearchForm() {
    const { filter } = this.state;

    this.context.router.push({
      pathname: '/owners/list',
      query: { 'lastName': filter || '' }
    });
  }

  dismissSuccessMessage() {
    this.setState({ successMessage: undefined });
    // Remove success message from URL without page reload
    this.context.router.replace({
      pathname: '/owners/list',
      query: this.state.filter ? { 'lastName': this.state.filter } : {}
    });
  }

  /** 
   * Actually loads data from the server
   */
  fetchData(filter: string) {
    const query = filter ? encodeURIComponent(filter) : '';
    const requestUrl = url('api/owners?lastName=' + query);

    fetch(requestUrl, createFetchOptions())
      .then(response => safeJsonParse(response))
      .then(owners => { 
        if (Array.isArray(owners)) {
          this.setState({ owners }); 
        } else {
          console.error('Invalid owners response:', owners);
          this.setState({ owners: [] });
        }
      })
      .catch(error => {
        console.error('Error loading owners:', error);
        this.setState({ owners: [] });
      });
  }

  render() {
    const { filter, owners, successMessage } = this.state;

    return (
      <span>
        {successMessage && (
          <div className='alert alert-success alert-dismissible' role='alert' style={{ marginBottom: '20px' }}>
            <button type='button' className='close' onClick={this.dismissSuccessMessage} aria-label='Close'>
              <span aria-hidden='true'>&times;</span>
            </button>
            <strong>Success!</strong> {successMessage}
          </div>
        )}
        <section>
          <h2>Find Owners</h2>

          <form className='form-horizontal' action='javascript:void(0)'>
            <div className='form-group'>
              <div className='control-group' id='lastName'>
                <label className='col-sm-2 control-label'>Last name </label>
                <div className='col-sm-10'>
                  <input className='form-control' name='filter' value={filter || ''} onChange={this.onFilterChange} size={30} maxLength={80} />
                  { /* <span className='help-inline'><form:errors path='*'/></span> TODO */}
                </div>
              </div>
            </div>
            <div className='form-group'>
              <div className='col-sm-offset-2 col-sm-10'>
                <button type='button' onClick={this.submitSearchForm} className='btn btn-default'>Find Owner</button>
              </div>
            </div>
          </form>
        </section>
        <OwnersTable owners={owners} />
        <Link className='btn btn-default' to='/owners/new'> Add Owner</Link>
      </span>
    );
  }
};
